<template>
    <div class="main">
        <my_menu active_name="1-0" :open_active="['1']"></my_menu>

        <div class="content">
            <DatePicker :model-value="mydate" @on-change="picker_change" format="yyyy-MM" type="month"
                placeholder="Select date" style="width: 200px" />
            <Spin fix v-if="loading"></Spin>

            <div>
                <div class="chart_title">
                    <span class="iconfont iconapi-fill"></span>
                    接口使用情况
                </div>
                <div class="loading_class">
                    <Spin fix v-if="loading"></Spin>
                    <div id="api_line">

                    </div>
                </div>
            </div>
            <div>
                <div class="chart_title">
                    <Icon type="md-compass" color="#0466dd" size="20" style="margin-right: 5px;" />网页使用情况
                </div>
                <div class="loading_class">
                    <Spin fix v-if="loading"></Spin>
                    <div id="web_line">

                    </div>
                </div>
            </div>
            <div>
                <div class="chart_title">
                    <Icon type="logo-android" color="green" size="22" style="margin-right: 5px;" />APP安卓端使用情况
                </div>
                <div class="loading_class">
                    <Spin fix v-if="loading"></Spin>
                    <div id="android_line">

                    </div>
                </div>
            </div>

            <div>

                <div class="chart_title">

                    <Icon type="logo-apple" color="#333" size="22" style="margin-right: 5px;" />APP苹果端使用情况
                </div>
                <div class="loading_class">
                    <Spin fix v-if="loading"></Spin>

                    <div id="ios_line">

                    </div>
                </div>
            </div>

        </div>

        <Modal v-model="show_user" :title="show_title" width="410">
            <div style="height: 200px;overflow: auto;">
                <span v-if="current_user_id_list.length == 0">没有数据</span>
                <div class="user_show_div">
                    <div v-for="item in current_user_id_list">
                        <Tag color="success">{{ user_detail_data[item] }}</Tag>


                    </div>
                </div>
            </div>
        </Modal>

        <Drawer title="当日数据" :closable="false" v-model="bar_show" width="80">

            <div>
                <div class="">
                    <div class="chart_title">
                        <span class="iconfont iconapi-fill"></span>{{ bar_date }}-API使用情况
                    </div>
                    <Spin fix v-if="bar_loading"></Spin>
                    <div id="api_day_line">

                    </div>
                </div>
            </div>
        </Drawer>
    </div>
</template>

<script>
import my_menu from '@/component/admin/menu/menu.vue'
import { http } from "@/utils/http.js";
import * as echarts from 'echarts';
export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            table_data: [],
            columns: [],
            table_loading: false,
            page: 1,
            mydate: this.generateDate(),
            show_user: false,
            user_detail_data: {},
            current_user_id_list: [],

            web_list_total: [],
            show_title: "",
            android_list_total: [],
            ios_list_total: [],
            bar_show: false,
            check_user_id_list_total: [],
            bar_user_num_list: [],
            bar_user_list: [],
            bar_user_id_list: [],
            loading: false,
            bar_loading: false,
            bar_date: ''


        }
    },

    mounted() {
        this.window_change()
        this.get_login_data()
    },

    methods: {



        picker_change(e) {
            this.mydate = e
            console.log(e)
            this.get_login_data()
        },

        generateDate() {
            var today = new Date();
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var day = today.getDate();

            // 添加前导零
            month = month < 10 ? '0' + month : month;
            day = day < 10 ? '0' + day : day;

            var formattedDate = year + '-' + month + '-' + day;

            return formattedDate;
        },


        create_bar_chart() {

            var chartDom = document.getElementById('api_day_line');
            var myChart = echarts.init(chartDom);
            var option;
            var that = this

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%', //默认10%
                    right: '4%', //默认10%
                    bottom: '8%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
                xAxis: {
                    type: 'category',
                    data: that.bar_user_list
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: that.bar_user_num_list,
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ]
            };

            option && myChart.setOption(option);

        },


        //创建网页登录折线图
        create_web_num_list_line(days, data) {

            var chartDom = document.getElementById('web_line');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%', //默认10%
                    right: '4%', //默认10%
                    bottom: '8%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
                xAxis: {
                    type: 'category',
                    data: days
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data,
                        type: 'line',
                        smooth: true
                    }
                ]
            };
            var that = this
            option && myChart.setOption(option);

            myChart.on('click', function (e) {
                console.log(e)
                that.current_user_id_list = that.web_list_total[e.dataIndex]
                that.show_title = e.name + '-Web用户列表'
                that.show_user = true

            })

        },
        //创建安卓登录折线图
        create_android_num_list_line(days, data) {

            var chartDom = document.getElementById('android_line');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%', //默认10%
                    right: '4%', //默认10%
                    bottom: '8%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
                xAxis: {
                    type: 'category',
                    data: days
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data,
                        type: 'line',
                        smooth: true
                    }
                ]
            };

            option && myChart.setOption(option);
            var that = this
            myChart.on('click', function (e) {
                console.log(e)
                that.current_user_id_list = that.android_list_total[e.dataIndex]
                that.show_title = e.name + '-安卓用户列表'
                that.show_user = true

            })

        },
        //创建ios登录折线图
        create_ios_num_list_line(days, data) {

            var chartDom = document.getElementById('ios_line');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%', //默认10%
                    right: '4%', //默认10%
                    bottom: '8%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
                xAxis: {
                    type: 'category',
                    data: days
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data,
                        type: 'line',
                        smooth: true
                    }
                ]
            };

            option && myChart.setOption(option);
            var that = this
            myChart.on('click', function (e) {
                console.log(e)
                that.current_user_id_list = that.ios_list_total[e.dataIndex]
                that.show_title = e.name + '-苹果用户列表'
                that.show_user = true

            })

        },

        //创建api登录折线图
        create_api_num_list_line(days, data) {

            var chartDom = document.getElementById('api_line');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%', //默认10%
                    right: '4%', //默认10%
                    bottom: '8%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
                xAxis: {
                    type: 'category',
                    data: days
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data,
                        type: 'line',
                        smooth: true
                    }
                ]
            };

            option && myChart.setOption(option);
            var that = this
            myChart.on('click', function (e) {
                console.log(e)
                that.bar_user_id_list = that.check_user_id_list_total[e.dataIndex]
                that.bar_show = true
                that.get_api_day_data(e.dataIndex)
                that.bar_date = e.name


            })

        },

        //获取当天接口登录数据
        get_api_day_data(day) {
            var that = this
            var date_list = that.mydate.split('-')
            var year = Number(date_list[0])
            var month = Number(date_list[1])
            var day = day += 1

            var obj = {
                user_id_list: that.bar_user_id_list,
                day,
                year,
                month

            }
            this.bar_loading = true
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/user_manage/usage_details/day_api_data", obj, true).then(
                (res) => {
                    if (res.code == 0) {

                        that.bar_user_num_list = res.data.user_num_list
                        that.bar_user_list = res.data.user_list
                        that.create_bar_chart()
                        that.bar_loading = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },


        //获取登录数据
        get_login_data() {
            var that = this
            var obj = {
                month: this.mydate
            }
            this.loading = true
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/user_manage/usage_details/login_data", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        var days = res.data.days
                        var web_num_list = res.data.web_num_list;
                        that.web_list_total = res.data.web_list_total
                        that.user_detail_data = res.data.user_detail_data
                        var ios_num_list = res.data.ios_num_list;
                        var android_num_list = res.data.android_num_list;
                        that.create_web_num_list_line(days, web_num_list)
                        that.ios_list_total = res.data.ios_list_total
                        that.android_list_total = res.data.android_list_total
                        that.check_user_id_list_total = res.data.check_user_id_list_total
                        that.create_ios_num_list_line(days, ios_num_list)
                        that.create_android_num_list_line(days, android_num_list)
                        that.create_api_num_list_line(days, res.data.check_num_list)
                        that.loading = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.loading_class {
    position: relative;
}

.iconapi-fill {
    color: #0466dd;
    font-size: 20px;
    margin-right: 5px;
}

.user_show_div {
    display: flex;
    flex-wrap: wrap;


}

.chart_title {
    padding-left: 5px;
    font-weight: 600;
    margin-top: 20px;
}

#api_day_line {
    margin: 10px 0;
    border-radius: 10px;
    background-color: #fff;
    height: calc(100vh - 300px);
}

#api_line {
    margin: 10px 0;
    border-radius: 10px;
    background-color: #fff;
    height: 300px;
}

#web_line {
    margin: 10px 0;
    border-radius: 10px;
    background-color: #fff;
    height: 300px;
}

#android_line {
    margin: 10px 0;
    border-radius: 10px;
    background-color: #fff;
    height: 300px;
}

#ios_line {
    margin: 10px 0;
    border-radius: 10px;
    background-color: #fff;
    height: 300px;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    padding: 10px;
    width: calc(100% - 220px);
    position: absolute;
    right: 10px;
    top: 10px;
    height: calc(100vh - 30px);
    overflow: auto;
    border-radius: 5px;
}

.main {
    background: #ececec;
    min-height: 100vh;
}
</style>